module.exports = __webpack_public_path__ + "img/snb_dksteel.9bc75fcb.svg";